import { render, staticRenderFns } from "./how-to-share-location-on-gb-whatsapp.vue?vue&type=template&id=cd3cf214"
import script from "./how-to-share-location-on-gb-whatsapp.vue?vue&type=script&lang=js"
export * from "./how-to-share-location-on-gb-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports